import React from 'react';
import type { FC } from 'react';
import { SelectInput } from '@wix/cli-ui-kit';
import { useTranslation } from '@wix/cli-i18n';
import { useCreateAppBi } from '../bi/index.js';

type AppCreationSource = 'template' | 'basic';

interface ChooseAppCreationSourceProps {
  onSelected: (appCreationSource: AppCreationSource) => void;
}

export const ChooseAppCreationSource: FC<ChooseAppCreationSourceProps> = ({
  onSelected,
}) => {
  const { t } = useTranslation();
  const { cliFlowStepAnswered } = useCreateAppBi();

  return (
    <SelectInput
      label={t('create_app.choose_app_creation_source.label')}
      options={[
        {
          title: t('create_app.choose_app_creation_source.basic_app.title'),
          description: t(
            'create_app.choose_app_creation_source.basic_app.description'
          ),
          value: 'basic' as const,
        },
        {
          title: t('create_app.choose_app_creation_source.template.title'),
          description: t(
            'create_app.choose_app_creation_source.template.description'
          ),
          value: 'template' as const,
        },
      ]}
      onSubmit={({ value }) => {
        cliFlowStepAnswered({
          question: t('create_app.choose_app_creation_source.label'),
          questionKey: 'create_app.choose_app_creation_source.label',
          answer: value,
        });
        onSelected(value);
      }}
    />
  );
};
